import { render } from "./Accordion.vue?vue&type=template&id=40c3559b&scoped=true"
import script from "./Accordion.vue?vue&type=script&lang=ts"
export * from "./Accordion.vue?vue&type=script&lang=ts"

import "./Accordion.vue?vue&type=style&index=0&id=40c3559b&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-40c3559b"

export default script